import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $numberUtils from '@/models/numberUtils.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const ifilAbsContract = require('./GovernanceVote.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.governanceVoteAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(ifilAbsContract.abi, contractAddress) : '',
}

const getGovernanceVoteAddress = () => {
    return contractAddress;
}

const getGovernanceVoteContract = () => {
    return contractConst.contract;
}
const getGovernanceVoteCfg = () => {
    return $web3js.call(getGovernanceVoteContract().methods.cfg, [], {}, handlCfgInfos);
};


const handlCfgInfos = async(res) => {
    let index = 0;
    let lockedDmc = res[index++];
    let rewardDmc = res[index++];
    let voteApy = res[index++];
    let benefitToken = res[index++];
    let reserved1 = res[index++];
    let reserved2 = res[index++];


    rewardDmc = await $erc20.fromErc20Value(rewardDmc, benefitToken);
    lockedDmc = await $erc20.fromErc20Value(lockedDmc, benefitToken);

    return {
        rewardDmc,
        lockedDmc,
        benefitToken
    };
};

const getconfigMapCfg = ([pid], options) => {
    return $web3js.call(getGovernanceVoteContract().methods.configMap, [pid], options, handlconfigMapCfgInfos);
};


const handlconfigMapCfgInfos = async(res) => {
    let index = 0;
    let lockedDmc = res[index++];
    let rewardDmc = res[index++];
    let voteApy = res[index++];
    let benefitToken = res[index++];
    let reserved1 = res[index++];
    let reserved2 = res[index++];


    rewardDmc = await $erc20.fromErc20Value(rewardDmc, benefitToken);
    lockedDmc = await $erc20.fromErc20Value(lockedDmc, benefitToken);

    return {
        rewardDmc,
        lockedDmc,
        voteApy
    };
};


const getpid2Standard = ([pid], options) => {
    console.log(pid)
    return $web3js.call(getGovernanceVoteContract().methods.pid2Standard, [pid], options, handlpid2StandardInfos);
};


const handlpid2StandardInfos = async(res) => {
    let index = 0;
    let totalVotes = res[index++];
    let supportRate = res[index++];
    let limitAddress = res[index++];
    let nDays = res[index++];

    let mvtAddress = $erc20.getErc20Address('MVT');
    totalVotes = await $erc20.fromErc20Value(totalVotes, mvtAddress);

    return {
        totalVotes,
        supportRate,
        limitAddress,
        nDays
    };
};

const getVoteInfoSum = ([_user], options) => {
    return $web3js.call(getGovernanceVoteContract().methods.getVoteInfoSum, [_user], options, handlVoteInfoSumInfos);
};


const handlVoteInfoSumInfos = async(res) => {
    let index = 0;
    let sumMvt = res[index++];
    let availBenefit = res[index++];

    let mvtAddress = $erc20.getErc20Address('MVT');
    let dmcAddress = $erc20.getErc20Address('DMC');
    sumMvt = await $erc20.fromErc20Value(sumMvt, mvtAddress);
    availBenefit = await $erc20.fromErc20Value(availBenefit, dmcAddress);

    return {
        sumMvt,
        availBenefit
    };
};


const getGovernanceVoteInfos = ([_user, _pids], options) => {
    return $web3js.call(
        getGovernanceVoteContract().methods.getVoteInfos, [_user, _pids], options,
        handlGovernanceVoteInfos
    );
};

const handlGovernanceVoteInfos = async(res2) => {
    console.log(res2)
    let resList = [];
    if (res2.length > 0) {
        for (let res of res2) {
            let index = 0;
            let pid = res[index++];
            let myyesCount = res[index++];
            let mynoCount = res[index++];
            let gainedBlock = res[index++];
            let unlockedBenefit = res[index++];
            let withdrawnBenefit = res[index++];
            let inited = res[index++];
            let mywithdrawYes = res[index++];
            let mywithdrawNo = res[index++];
            let finished = res[index++];;
            let reserved1 = res[index++];
            let reserved2 = res[index++];
            let reserved3 = res[index++];
            let reserved4 = res[index++];
            let reserved5 = res[index++];

            let mvtAddress = $erc20.getErc20Address('MVT');
            let dmcAddress = $erc20.getErc20Address('DMC');
            myyesCount = await $erc20.fromErc20Value(myyesCount, mvtAddress);
            mynoCount = await $erc20.fromErc20Value(mynoCount, mvtAddress);
            mywithdrawYes = await $erc20.fromErc20Value(mywithdrawYes, mvtAddress);
            mywithdrawNo = await $erc20.fromErc20Value(mywithdrawNo, mvtAddress);
            let myBenefit = $numberUtils.sub(unlockedBenefit, withdrawnBenefit);
            let myCountMVT = $numberUtils.add(myyesCount, mynoCount);
            let mywithdrawCount = $numberUtils.add(mywithdrawYes, mywithdrawNo);
            myBenefit = await $erc20.fromErc20Value(myBenefit, dmcAddress);


            let item = {
                myyesCount,
                mynoCount,
                myBenefit,
                finished,
                myCountMVT,
                mywithdrawCount


            }
            resList.push(item);

        }
        return resList;
    }
};


const getGovernanceVoteProposals = () => {
    return $web3js.call(getGovernanceVoteContract().methods.getProposals, [], {}, handlProposalsInfos);
}

const handlProposalsInfos = async(res2) => {
    console.log(res2)
    let resList = [];
    if (res2.length > 0) {
        for (let res of res2) {
            let index = 0;
            let pid = res[index++];
            let issueUser = res[index++];
            let lockedDmc = res[index++];
            let withdrawDmc = res[index++];
            let rewardDmc = res[index++];
            let yesCount = res[index++];
            let withdrawYes = res[index++];
            let noCount = res[index++];
            let withdrawNo = res[index++];
            let issueTime = res[index++];
            let issueBlock = res[index++];
            let votePeriod = res[index++];
            let endTime = res[index++];
            let endBlock = res[index++];
            let gainedBlock = res[index++];
            let unlockedBenefit = res[index++];
            let withdrawnBenefit = res[index++];
            let state = res[index++];
            let title = res[index++];
            let content = res[index++];
            let unlockedDmcState = res[index++];
            let reserved2 = res[index++];
            let reserved3 = res[index++];
            let reserved4 = res[index++];
            let reserved5 = res[index++];
            let mvtAddress = $erc20.getErc20Address('MVT');
            let dmcAddress = $erc20.getErc20Address('DMC');
            lockedDmc = await $erc20.fromErc20Value(lockedDmc, dmcAddress);
            withdrawDmc = await $erc20.fromErc20Value(withdrawDmc, dmcAddress);
            yesCount = await $erc20.fromErc20Value(yesCount, mvtAddress);
            noCount = await $erc20.fromErc20Value(noCount, mvtAddress);


            let item = {
                pid,
                title,
                state,
                yesCount,
                noCount,
                issueTime,
                endTime,
                lockedDmc,
                withdrawDmc


            }
            resList.push(item);

        }
        return resList;
    }
};

const getGovernanceVoteProposalsById = ([_pids], options) => {
    return $web3js.call(getGovernanceVoteContract().methods.getProposals, [_pids], options, handlProposalsInfos);
}

const launchProposal = ([title, content], options, callback) => {
    return $web3js.send(getGovernanceVoteContract().methods.launchProposal, [
        title, content
    ], options, callback);
};

const launchProposalEstimateSend = async([title, content], options) => {
    let gasPromise = $web3js.estimateSend(
        getGovernanceVoteContract().methods.launchProposal, [title, content], options
    );
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

const launchProposalvote = async([_pid, support, _ticket], options, callback) => {
    let mvtAddress = $erc20.getErc20Address('MVT');
    _ticket = await $erc20.toErc20Value(_ticket, mvtAddress);
    console.log(_pid)
    console.log(support)
    console.log(_ticket)
    return $web3js.send(getGovernanceVoteContract().methods.vote, [
        _pid, support, _ticket
    ], options, callback);
};

const launchProposalvoteEstimateSend = async([_pid, support, _ticket], options) => {
    let mvtAddress = $erc20.getErc20Address('MVT');
    _ticket = await $erc20.toErc20Value(_ticket, mvtAddress);
    let gasPromise = $web3js.estimateSend(
        getGovernanceVoteContract().methods.vote, [_pid, support, _ticket], options
    );
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

const Voteredeem = async([_pid], options, callback) => {
    return $web3js.send(getGovernanceVoteContract().methods.redeem, [
        _pid
    ], options, callback);
};

const VoteredeemEstimateSend = async([_pid], options) => {
    let gasPromise = $web3js.estimateSend(
        getGovernanceVoteContract().methods.redeem, [_pid], options
    );
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}


const VotereredeemPledgeDmc = async([_pid], options, callback) => {
    console.log(_pid)
    return $web3js.send(getGovernanceVoteContract().methods.redeemPledgeDmc, [
        _pid
    ], options, callback);
};

const VotereredeemPledgeDmcEstimateSend = async([_pid], options) => {
    let gasPromise = $web3js.estimateSend(
        getGovernanceVoteContract().methods.redeemPledgeDmc, [_pid], options
    );
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

export default {
    getGovernanceVoteAddress,
    getGovernanceVoteContract,
    getGovernanceVoteInfos,
    getGovernanceVoteProposals,
    getGovernanceVoteCfg,
    launchProposal,
    launchProposalEstimateSend,
    getconfigMapCfg,
    launchProposalvote,
    launchProposalvoteEstimateSend,
    getGovernanceVoteProposalsById,
    getVoteInfoSum,
    Voteredeem,
    VoteredeemEstimateSend,
    VotereredeemPledgeDmc,
    VotereredeemPledgeDmcEstimateSend,
    getpid2Standard

}


// WEBPACK FOOTER //
// ./src/lib/contract/governanceVote/index.js